let devApi = {
    chat:"http://10.252.219.22:3000/mock/replyMessage.json",
    jumpUrl:{
        set:"https://hrgbot.58.com/mcommonchat/set",
        springyymain:"//zp.58.com/yy/2019sp/index",
        springyygame:"//zp.58.com/yy/2019/game/index",
        cvip:"//cvip.58.com/m#/feedBackAdd",
        yycvip:"//cvip.58.com/m"
    }
}
//http://10.8.8.206:8001/replyMessage
let prdApi ={
    // chat:"https://zpchatbot.58.com/replyMessage",
    chat:"https://zpchatbot.58.com/replymessageV2",
    // chat:"http://localhost:3000/replymessageV2",
    jumpUrl:{
        index:"https://hrgbot.58.com/mcommonchat",
        appchatbotindex:"https://hrgbot.58.com/mchat",
        set:"https://hrgbot.58.com/mcommonchat/set",
        springyymain:"//zp.58.com/yy/2019sp/index",
        springyygame:"//zp.58.com/yy/2019/game/index",
        cvip:"https://cvip.58.com/m#/feedBackAdd",
        yycvip:"https://cvip.58.com/m"
    }
}

//export default devApi;
export default prdApi;


// if (process.env.NODE_ENV === 'production') {
//     //export default 
//   } else {
//     //module.exports = proData;
//     module.exports = devData;
//   } 